<template>
    <v-container class="pl-0">
        <entity-nav :navItems="navItems" useEvents></entity-nav>
        <keep-alive exclude="MonsterReader, MonsterEditor">
            <router-view></router-view>
        </keep-alive>
    </v-container>
</template>
<script>
import EntityNav from '../../components/EntityNav.vue'
import { mapState } from 'vuex'
import permissionsSet from '../../components/permissions'
const entity = 'monster'
export default {
    name: 'MonsterHome',
    components: {
        'entity-nav': EntityNav,
    },
    computed: {
        ...mapState(['user']),
        navItems() {
            let items = [
                { title: 'Monster Manual', icon: 'mdi-book-open-variant-outline', to: 'monsterManual' },
                { title: 'Your List', icon: 'mdi-view-list', to: 'monster' },
                { title: 'Archive', icon: 'mdi-delete-outline', to: 'monsterArchive' },
            ]
            if (this.canCreate) items = [{ title: 'New', icon: 'mdi-plus', to: 'newMonster' }, ...items]

            return items
        },
        canCreate() {
            console.log(this.user)
            if (this.user && this.user[entity]) {
                return this.user[entity].owned.includes(permissionsSet.Create)
            } else {
                return false
            }
        },
    },
}
</script>
<style>
.entityView {
    width: 100%;
}
</style>
